module.exports = __webpack_public_path__ + "img/score-bg3.bd695265.png";